import React from "react";

import { Button, Card, FormGroup, Slider } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";
import { LIGHT_BACKGROUND, MIDTEXT_COLOR } from "@/css/constants";

interface PerformanceSimulatorProps {
  monthlyPerformances: number[];
  setMonthlyPerformances: React.Dispatch<React.SetStateAction<number[]>>;
}

function PerformanceSimulator({
  monthlyPerformances,
  setMonthlyPerformances,
}: PerformanceSimulatorProps) {
  // Performance scenarios
  const realisticRamp = [0, 25, 50, 75, 100, 100, 110, 90, 120, 100, 100, 150];
  const slowStart = [0, 0, 25, 50, 75, 100, 100, 100, 100, 100, 100, 100];
  const bigDealCycle = [0, 0, 0, 300, 50, 50, 0, 0, 350, 25, 25, 0];
  const topPerformer = [
    100, 130, 160, 200, 250, 300, 350, 400, 400, 400, 400, 400,
  ];

  return (
    <Box mt={36}>
      <Box
        as="h2"
        mb={3}
        fontSize="18px"
        fontWeight={600}
        color={MIDTEXT_COLOR}
      >
        Performance Simulation
      </Box>
      <Box>
        <FormGroup
          label="Monthly Performance (% of Quota)"
          labelFor="perf-simulation"
          style={{ marginBottom: "8px" }}
        >
          <Card
            elevation={0}
            style={{
              padding: "16px",
              border: "1px solid #D1D5DB",
              boxShadow: "none",
            }}
          >
            <Flex
              backgroundColor={LIGHT_BACKGROUND}
              className="round-corners"
              p={2}
              mb={3}
              flexWrap="wrap"
              css={{ gap: "8px" }}
            >
              <Button
                small
                onClick={() => setMonthlyPerformances(realisticRamp)}
              >
                Realistic Ramp
              </Button>
              <Button small onClick={() => setMonthlyPerformances(slowStart)}>
                Slow Start
              </Button>
              <Button
                small
                onClick={() => setMonthlyPerformances(bigDealCycle)}
              >
                Big Deal Cycle
              </Button>
              <Button
                small
                onClick={() => setMonthlyPerformances(topPerformer)}
              >
                Top Performer
              </Button>
            </Flex>
            <Flex flexWrap="wrap" css={{ gap: "16px" }}>
              {monthlyPerformances.map((perf, idx) => (
                <Box key={idx} width={["100%", "45%", "30%"]} mb={2}>
                  <Box
                    fontSize="12px"
                    fontWeight={500}
                    color={MIDTEXT_COLOR}
                    mb={1}
                  >
                    Month {idx + 1}: {perf}%
                  </Box>
                  <Slider
                    min={0}
                    max={400}
                    stepSize={10}
                    labelRenderer={false}
                    value={perf}
                    onChange={(value) => {
                      const newPerformances = [...monthlyPerformances];
                      newPerformances[idx] = value;
                      setMonthlyPerformances(newPerformances);
                    }}
                  />
                </Box>
              ))}
            </Flex>
          </Card>
        </FormGroup>
      </Box>
    </Box>
  );
}

export default PerformanceSimulator;
